<template>
  <TemplateCopyfrom tool="editor"> </TemplateCopyfrom>
</template>

<script>
import TemplateCopyfrom from '../layout/TemplateCopyfrom';

export default {
  name: 'editor-copyfrom',
  components: {
    TemplateCopyfrom,
  },
};
</script>

<style></style>
